import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import useAuth from '../controllers/users/useAuth';

export default function PublicRoute({ component: Component, ...rest }) {

    const auth = useAuth();
    return (
        <Route {...rest}>
            {!auth?.isLoged() ? (<Component />) : (<Redirect to='/'/>)}
        </Route>
    )
}